import { DatePicker, TabMenu } from '@/shared/ui';
import moment from 'moment';
import { useEffect } from 'react';

type ByPublishStntDetailListFilterProps = {
    startDate?: Date;
    endDate?: Date;
    dateTab?: string;

    setStartDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
    setEndDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
    setDateTab: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const ByPublishStntDetailListFilter = ({
    startDate,
    endDate,
    dateTab,
    setStartDate,
    setEndDate,
    setDateTab,
}: ByPublishStntDetailListFilterProps) => {
    useEffect(() => {
        onDateButton('3');
    }, []);

    const onDateChange = async (date: Date, rangeType: 's' | 'e') => {
        const start = date;
        const end = endDate ? endDate : undefined;
        setDateTab(undefined);

        switch (rangeType) {
            case 's':
                setStartDate(date);

                if (end && end < start) {
                    const newEnd = new Date(start);
                    newEnd.setDate(newEnd.getDate() + 1);
                    setEndDate(newEnd);
                }
                break;
            case 'e':
                setEndDate(date);
                break;
        }
    };

    const onDateButton = async (type: string) => {
        setDateTab(type);
        const newStart = new Date();
        const current = new Date();
        if (type === '0') {
            setStartDate(undefined);
            setEndDate(undefined);
        } else {
            if (type === '7') {
                newStart.setDate(newStart.getDate() - Number(type));
                setStartDate(newStart);
                setEndDate(current);
            } else {
                const monthStart = moment().subtract(Number(type), 'months').toDate();
                setStartDate(monthStart);
                setEndDate(current);
            }
        }
    };

    return (
        <div className="table-input table-style1 // con-mt1">
            <table>
                <colgroup>
                    <col style={{ width: '121px' }} />
                    <col style={{ width: '529px' }} />
                    <col style={{ width: '121px' }} />
                    <col />
                </colgroup>
                <tbody>
                    <tr className="row-gap1">
                        <th scope="row">발행일</th>
                        <td colSpan={3}>
                            <div className="datepicker-period">
                                <div className="datepicker">
                                    <DatePicker
                                        placeholderText={'시작 일 선택'}
                                        selectsStart
                                        date={startDate!}
                                        maxDate={endDate}
                                        changed_date={(date: Date) => onDateChange(date, 's')}
                                        // disabled={startDisabled}
                                    />
                                </div>
                                <span className="ico">~</span>
                                <div className="datepicker">
                                    <DatePicker
                                        placeholderText={'종료 일 선택'}
                                        selectsEnd
                                        date={endDate!}
                                        maxDate={new Date('9999-12-31')}
                                        changed_date={(date: Date) => onDateChange(date, 'e')}
                                    />
                                </div>
                            </div>
                            <TabMenu
                                tabType={2}
                                tabItems={[
                                    { tabName: '1주', value: '7' },
                                    { tabName: '1개월', value: '1' },
                                    { tabName: '3개월', value: '3' },
                                ]}
                                selected={dateTab}
                                className="tab-size2"
                                onChange={(value: string) => onDateButton(value)}
                                reset={true}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
